import { Longhand } from "../longhand.js";
import Base, { compute } from "./border-top-width.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-block-start-width}
 * @internal
 */
export default Longhand.extend(Base, {
    compute: (borderWidth, style) => {
        const borderStyle = style.computed("border-block-start-style");
        return compute(borderStyle, borderWidth, style);
    },
});
//# sourceMappingURL=border-block-start-width.js.map